<template>
  <tr>
    <td>
      <div class="pa-1">
        <p class="text-subtitle-1 mb-0">
          {{ item.label }}
        </p>
        <p
          v-if="item.description"
          class="text-caption"
        >
          {{ item.description }}
        </p>
      </div>
    </td>
    <td>
      <div class="checkbox-column">
        <v-checkbox
          v-model="data.email"
          hide-details
        />
      </div>
    </td>
    <td>
      <div class="checkbox-column">
        <v-checkbox
          v-model="data.app"
          hide-details
        />
      </div>
    </td>
  </tr>
</template>
<script>
import { authAxios } from '../../../auth/utils'
export default {
  props: {
    item: { type: Object, required: true }
  },
  data() {
    return {
      data: this.item
    }
  },
  watch: {
    data: {
      handler() {
        authAxios.put('/settings', this.data)
        this.$emit('update:item', this.data)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
  .checkbox-column {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .checkbox-column > * {
    margin-top: 0 !important;
  }
</style>
